import { configure } from 'mobx'
import RootStore from './RootStore'
import AuthenticatedUserStore from './AuthenticatedUserStore'
import NotifierStore from './NotifierStore'

const rootStore = new RootStore({
    notifierStore: NotifierStore,
    authenticatedUserStore: AuthenticatedUserStore,
})

configure({ enforceActions: 'observed' }) // Enables strict mode for observed properties.
export default rootStore
export const { authenticatedUserStore, notifierStore } = rootStore
